/** Ids, labels and defaults for the project page's 3D view. */

export const VIEW3D_SIDEBAR_ID = 'view3dSettings';

export const MEASURE_COLOR = '#ffcc33';
export const MEASURE_HOVER_COLOR = '#ff5c5c';

export const POINT_CLOUD_DEFAULTS = Object.freeze({
	size: 2,
	opacity: 1,
	colorMode: 'photo', // 'photo' | 'height'
});

/** How far (m) a measurement vertex may move to snap onto a point of the point cloud. */
export const SNAP_DISTANCE_M = 0.5;

/** Splats fainter than this are not surfaces and are skipped when picking. */
export const MIN_RAYCAST_OPACITY = 0.3;
